/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEhrDocument } from './ExternalEhrDocument';
import {
    ExternalEhrDocumentFromJSON,
    ExternalEhrDocumentFromJSONTyped,
    ExternalEhrDocumentToJSON,
} from './ExternalEhrDocument';

/**
 * 
 * @export
 * @interface LeadScreenerAdditionalDocumentsInner
 */
export interface LeadScreenerAdditionalDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    content_type?: string;
    /**
     * 
     * @type {number}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    filesize_in_bytes?: number;
    /**
     * 
     * @type {number}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    page_count?: number;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    s3_access_url?: string;
    /**
     * 
     * @type {ExternalEhrDocument}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    external_ehr_document?: ExternalEhrDocument;
    /**
     * 
     * @type {string}
     * @memberof LeadScreenerAdditionalDocumentsInner
     */
    combined_from_lead_id?: string;
}

/**
 * Check if a given object implements the LeadScreenerAdditionalDocumentsInner interface.
 */
export function instanceOfLeadScreenerAdditionalDocumentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function LeadScreenerAdditionalDocumentsInnerFromJSON(json: any): LeadScreenerAdditionalDocumentsInner {
    return LeadScreenerAdditionalDocumentsInnerFromJSONTyped(json, false);
}

export function LeadScreenerAdditionalDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerAdditionalDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': json['s3_key'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
        'filesize_in_bytes': !exists(json, 'filesize_in_bytes') ? undefined : json['filesize_in_bytes'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        's3_access_url': !exists(json, 's3_access_url') ? undefined : json['s3_access_url'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : ExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'combined_from_lead_id': !exists(json, 'combined_from_lead_id') ? undefined : json['combined_from_lead_id'],
    };
}

export function LeadScreenerAdditionalDocumentsInnerToJSON(value?: LeadScreenerAdditionalDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'created_at': value.created_at,
        'content_type': value.content_type,
        'filesize_in_bytes': value.filesize_in_bytes,
        'page_count': value.page_count,
        's3_access_url': value.s3_access_url,
        'external_ehr_document': ExternalEhrDocumentToJSON(value.external_ehr_document),
        'combined_from_lead_id': value.combined_from_lead_id,
    };
}

